import { OOCanvas } from './oo-canvas';
import { OOMenuItem } from './oo-menu-item';
import { OOCanvasMenuItemTimeRange } from './OOCanvasMenuItemTimeRange.entity';

export class OOCanvasMenuItem {
	venueKey: number;

	canvasKey: number;

	menuItemKey: number;

	online?: boolean;

	taxable?: boolean;

	description?: string;

	displayName?: string;

	priceNumber?: number;

	priceLevelEnforced?: boolean;

	sortOrder: number;

	isAlcohol: boolean;
	quickAdd: boolean;
	source: number;
	preselected?: boolean;
	priceNumberExtra: number;
	priceNumberNo: number;
	priceNumberLite: number;
	includedItem: boolean;
	ooCanvas?: OOCanvas;
	hideImages?: boolean;

	ooMenuItem?: OOMenuItem;

	subscriptionItem: boolean;
	subscriptionAllowedFrequencies: number[];
	subscriptionFrequencyDisplayName: string[];

	includedItemCanvases: OOCanvas[];
	modifierCanvases: OOCanvas[];

	OOCanvasMenuItemTimeRange: OOCanvasMenuItemTimeRange[];

	unsaved: boolean; //not from backend. Local var
	price: number; //local var

	includedModifierSelectOptions: IncludedModifierSelectOptions[];
	includedModifierOptionSelectedNumber: number;
	includedModifierOptionSelectedName: string;
	includedModifierSelectedDefault: any;

	public constructor(init?: Partial<OOCanvasMenuItem>) {
		Object.assign(this, init);
	}
}

export interface IncludedModifierSelectOptions {
	name: string;
	value: number;
	menuItemKey: number;
	canvasMenuItem: OOCanvasMenuItem;
	default: boolean;
	includedModType: number;
}
